import { EIncludedType } from '../api/models/member/member.types';
import { ICompatibilityReport, IMembersEntries } from './types';

export type IMembersAction =
  | IGetMemberProfileSuccesAction
  | IGetCompatibilityReportLight
  | IGetCompatibilityReportLightSuccess;

export enum EMembersProfileActionType {
  GET = 'MEMBER_PROFILE_GET',
  GET_SUCCESS = 'MEMBER_PROFILE_GET_SUCCESS',
  GET_COMPATIBILITY_REPORT_LIGHT = 'MEMBER/GET_COMPATIBILITY_REPORT',
  GET_COMPATIBILITY_REPORT_LIGHT_SUCCESS = 'MEMBER/GET_COMPATIBILITY_REPORT_SUCCESS',
}

export interface IGetMemberProfilePayload {
  accountId: string;
}

export interface IGetMemberProfileIncludingPayload
  extends IGetMemberProfilePayload {
  includes?: EIncludedType[];
}

export type IGetMemberProfileSuccessPayload = IMembersEntries;

export interface IGetMemberProfileAction {
  type: EMembersProfileActionType.GET;
  payload: IGetMemberProfileIncludingPayload;
}

export const getMemberProfileAction = (
  payload: IGetMemberProfileIncludingPayload
): IGetMemberProfileAction => ({
  type: EMembersProfileActionType.GET,
  payload: {
    includes: [
      EIncludedType.ANNOUNCE,
      EIncludedType.PHOTO_REVEAL_STATUS,
      EIncludedType.FAVORITE,
      EIncludedType.BLACKLIST,
      EIncludedType.LAST_CONNECTION,
    ],
    ...payload,
  },
});

export interface IGetMemberProfileSuccesAction {
  type: EMembersProfileActionType.GET_SUCCESS;
  payload: IGetMemberProfileSuccessPayload;
}

export const getMemberProfileSuccessAction = (
  payload: IGetMemberProfileSuccessPayload
): IGetMemberProfileSuccesAction => ({
  type: EMembersProfileActionType.GET_SUCCESS,
  payload,
});

export interface IGetCompatibilityReportLightPayload {
  accountId: string;
}

export interface IGetCompatibilityReportLight {
  type: EMembersProfileActionType.GET_COMPATIBILITY_REPORT_LIGHT;
  payload: IGetCompatibilityReportLightPayload;
}

export const getCompatibilityReportLight = (
  payload: IGetCompatibilityReportLightPayload
): IGetCompatibilityReportLight => ({
  type: EMembersProfileActionType.GET_COMPATIBILITY_REPORT_LIGHT,
  payload,
});

export interface IGetCompatibilityReportLightSuccess {
  type: EMembersProfileActionType.GET_COMPATIBILITY_REPORT_LIGHT_SUCCESS;
  payload: ICompatibilityReport;
}

export const getCompatibilityReportLightSuccess = (
  payload: ICompatibilityReport
): IGetCompatibilityReportLightSuccess => ({
  type: EMembersProfileActionType.GET_COMPATIBILITY_REPORT_LIGHT_SUCCESS,
  payload,
});
